// export const ROOT_URL = 'http://localhost:8080';
export const ROOT_URL = 'https://api-test.dialogvault.com';
// export const ROOT_URL = 'https://api.dialogvault.com';
